import React, { PureComponent } from "react";
import MarketCaptureChart from "./charts/market-capture";
import HelpIconButtonWithTooltip from "../../../ui-building-blocks/icons/HelpIconButtonWithTooltip";

class MarketCapture extends PureComponent {
  getDataValue(team_id, key) {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    const val = data[team_id][key];

    if (!val) {
      return 0;
    }

    return val;
  }

  get dataMobile() {
    const { teams } = this.props;
    let chartData = [];

    Object.keys(teams).forEach(team_id => {
      chartData.push({
        team: teams[team_id],
        value: Math.abs(this.getDataValue(team_id, "Units Sold Mobile"))
      });
    });

    return chartData;
  }

  get dataAuto() {
    const { teams } = this.props;
    let chartData = [];

    Object.keys(teams).forEach(team_id => {
      chartData.push({
        team: teams[team_id],
        value: Math.abs(this.getDataValue(team_id, "Units Sold Auto"))
      });
    });

    return chartData;
  }

  render() {
    const { total_demand } = this.props;

    return (
      <div className="row">
        <div className="col-md-6 col-xs-12">
          <div className="bg-white">
            <div className="pt-30 pl-30 pr-30">
              <h5>
                MARKET CAPTURE - MOBILE
                <HelpIconButtonWithTooltip
                  category="Market Capture Mobile"
                  tooltipContent="This section shows the # of units you were able to sell in the market in relation to your competitors."
                  iconSize="sm"
                />
              </h5>
              <hr></hr>
            </div>
            <MarketCaptureChart
              data={this.dataMobile}
              totalDemand={total_demand.mobile}
            />
          </div>
        </div>
        <div className="col-md-6 col-xs-12">
          <div className="bg-white">
            <div className="pt-30 pl-30 pr-30">
              <h5>
                MARKET CAPTURE - AUTO
                <HelpIconButtonWithTooltip
                  category="Market Capture Auto"
                  tooltipContent="This section shows the # of units you were able to sell in the market in relation to your competitors."
                  iconSize="sm"
                />
              </h5>
              <hr></hr>
            </div>
            <MarketCaptureChart
              data={this.dataAuto}
              totalDemand={total_demand.auto}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MarketCapture;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/market-capture.js